import {isTruthy} from "../../../Utility/logic";

/**
 * Informs the customer that the agent has marked it tax exempt. Right sidebar.
 *
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function CustomerPoNumberIndicator({shoppingCart={}}) {
  const { customerPoNumber } = shoppingCart;

  if (!customerPoNumber) return null;

  return <div className="text-center">
    <span className="fas fa-file-spreadsheet text-gray-800 mx-2"/>
    Customer PO# <b>{customerPoNumber}</b>
    </div>
}
